export default "__VITE_ASSET__DIYtUN5K__"